import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { forkJoin } from 'rxjs';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

interface StatisticsDTO {
  waybillsTotali: number;
  waybillsDMDC: number;
  waybillsBigOrders: number;
  parcelsTotali: number;
  parcelsDMDC: number;
  parcelsBigOrders: number;
  parcelsMancanti: number;
  parcelsBigOrdersPTV: number;
}

interface Dealer {
  dealerCode: string | null;
  dealerName: string | null;
  dealerOperatingAddressCity: string | null;
  count?: number;
}

interface Warehouse {
  warehouseCode: string;
  warehouseName?: string;
}

interface Region {
  regionCode: string;
  regionName?: string;
}

interface Client {
  clientCode: string;
  clientName?: string;
}

interface Brand {
  brandCode: string;
  brandName?: string;
}

interface ClientsBrands {
  clientCode: string;
  clientName?: string;
  brands: Brand[];
}

@Component({
  selector: 'app-statistics-affidati',
  standalone: true,
  templateUrl: './statistics-affidati.component.html',
  styleUrls: ['./statistics-affidati.component.css'],
  imports: [FormsModule, CommonModule, TranslateModule, NgMultiSelectDropDownModule]
})
export class StatisticsAffidatiComponent implements OnInit {

  stats?: StatisticsDTO;
  loading = false;
  error = '';
  warning = '';

  dateBefore26: boolean = false;

  // Filtri selezionati
  waybillDealerCode: string = '';
  warehouseCode: string = '';
  waybillDateStart: string = new Date().toISOString().split('T')[0];
  waybillDateEnd: string = new Date().toISOString().split('T')[0];
  waybillCode: string = '';
  regionCode: string = '';
  
  filteredBrands: Brand[] = [];

  // Opzioni select
  filteredDealers: Dealer[] = [];
  filteredWarehouses: Warehouse[] = [];
  filteredRegions: Region[] = [];

  constructor(private http: HttpClient) {}

  selectedBrands: Brand[] = [];
  filteredClients: Client[] = [];
  selectedClients: Client[] = [];
  clientsBrands: ClientsBrands[] = [];
  
  dropdownSettingsBrand: IDropdownSettings = {};
  dropdownSettingsClient: IDropdownSettings = {};

  // ngOnInit(): void {
  //   forkJoin({
  //     dealers: this.http.get<Dealer[]>(`${environment.apiUrl}/tracking/dealers`),
  //     brands: this.http.get<Brand[]>(`${environment.apiUrl}/shipment-request/brands`),
  //     warehouses: this.http.get<Warehouse[]>(`${environment.apiUrl}/tracking/warehouses`),
  //     regions: this.http.get<Region[]>(`${environment.apiUrl}/tracking/regions`),
  //   }).subscribe({
  //     next: (results) => {
  //       this.filteredDealers = results.dealers;
  //       this.filteredBrands = results.brands;
  //       this.filteredWarehouses = results.warehouses;
  //       this.filteredRegions = results.regions;
  //       this.dropdownSettings = {
  //         singleSelection: false,
  //         idField: 'brandCode',
  //         textField: 'brandName',
  //         selectAllText: 'Seleziona tutti',
  //         unSelectAllText: 'Deseleziona tutti',
  //         itemsShowLimit: 3,
  //         allowSearchFilter: true
  //       };
  //       this.calcolaDataDefaultFiltri();
  //       this.fetchStatistics(); 
  //       this.confrontaDate();
  //     },
  //     error: (err) => {
  //       console.error('Errore nel caricamento iniziale:', err);
  //     }
  //   });
  // }

  ngOnInit(): void {

    this.warning = 'Selezionare almeno un cliente o un marchio per visualizzare le statistiche.';

    this.calcolaDataDefaultFiltri();
    this.confrontaDate();

    const stored = localStorage.getItem('userFunctions');
    if(stored) {
      const parsed = JSON.parse(stored);
      this.clientsBrands = parsed.clients;

    this.filteredClients = this.clientsBrands.map(cb => ({
        clientCode: cb.clientCode,
        clientName: cb.clientName,
      }))
      .sort((a, b) => {
        if (!a.clientName && !b.clientName) return 0;       
        if (!a.clientName) return 1;                        
        if (!b.clientName) return -1;                       
        return a.clientName.localeCompare(b.clientName);   
      });

      const allBrands: Brand[] = this.clientsBrands.flatMap(cb =>
        cb.brands.map(b => ({
          brandCode: b.brandCode,
          brandName: b.brandName,
        }))
      ).sort((a, b) => {
        if (!a.brandName && !b.brandName) return 0;       
        if (!a.brandName) return 1;                        
        if (!b.brandName) return -1;                       
        return a.brandName.localeCompare(b.brandName);   
      });

      // rimuovo duplicati nei brands (se lo vuoi)
      this.filteredBrands = Array.from(
        new Map(allBrands.map(b => [b.brandCode, b])).values()
      );

      this.dropdownSettingsBrand = {
        singleSelection: false,
        idField: 'brandCode',
        textField: 'brandName',
        selectAllText: 'Seleziona tutti',
        unSelectAllText: 'Deseleziona tutti',
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: 'Cerca'
      };
      this.dropdownSettingsClient = {
        singleSelection: false,
        idField: 'clientCode',
        textField: 'clientName',
        selectAllText: 'Seleziona tutti',
        unSelectAllText: 'Deseleziona tutti',
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: 'Cerca'
      };
  
      forkJoin({
          dealers: this.http.post<Dealer[]>(`${environment.apiUrl}/tracking/dealers`, this.clientsBrands),
          warehouses: this.http.get<Warehouse[]>(`${environment.apiUrl}/tracking/warehouses`),
          regions: this.http.get<Region[]>(`${environment.apiUrl}/tracking/regions`)
      }).subscribe({
        next: (results) => {
          this.filteredDealers = results.dealers;
          this.filteredWarehouses = results.warehouses;
          this.filteredRegions = results.regions;
          //this.fetchStatistics();
        },
        error: (err) => {
          console.error('Errore nel caricamento iniziale:', err);
        }
      });
    }
  }

  onClientsChange(): void {
    this.getIntersectionClientsBrands();
  }

  getIntersectionClientsBrands() : void {
    if (!this.selectedClients || this.selectedClients.length === 0) {
      // Nessun client selezionato → mostro tutti i brands
      this.filteredBrands = Array.from(
        new Map(
          this.clientsBrands
            .flatMap(cb => cb.brands)
            .map(b => [b.brandCode, b])
        ).values()
      );
      this.selectedBrands = []; // reset
      return;
    }

    // prendo i codici dei client selezionati
    const selectedCodes = this.selectedClients.map(c => c.clientCode);

    // ottengo i brands per ogni client selezionato
    const brandLists = selectedCodes.map(code => {
      const client = this.clientsBrands.find(cb => cb.clientCode === code);
      return client ? client.brands : [];
    });

    // calcolo l’intersezione tra tutte le liste
    const intersection = brandLists.reduce((acc, curr) => {
      return acc.filter(b =>
        curr.some(x => x.brandCode === b.brandCode)
      );
    });

    // aggiorno i brands disponibili
    this.filteredBrands = intersection;
    this.selectedBrands = []; // reset per evitare selezioni incoerenti
  }


  selectAllClients() {
    this.selectedClients = [...this.filteredClients];

    this.getIntersectionClientsBrands();
  }

  deselectAllClients() {
    this.selectedClients = [];

    this.getIntersectionClientsBrands();
  }

  selectAllBrands() {
    this.selectedBrands = [...this.filteredBrands];
  }

  deselectAllBrands() {
    this.selectedBrands = [];
  }

  confrontaDate(): void {
    this.dateBefore26 = false;
    
    const start = new Date('2025-06-26');
    const data = new Date(this.waybillDateStart);

    start.setHours(0, 0, 0, 0);
    data.setHours(0, 0, 0, 0);

    if (data <= start) {
      this.dateBefore26 = true;
    }
  }


  loadDealers(): void {
    this.http.post<Dealer[]>(`${environment.apiUrl}/tracking/dealers`, this.clientsBrands).subscribe({
      next: (data) => this.filteredDealers = data,
      error: () => console.error('Errore nel caricamento dei dealer')
    });
  }

  loadWarehouses(): void {
    this.http.get<Warehouse[]>(`${environment.apiUrl}/tracking/warehouses`).subscribe({
      next: (data) => this.filteredWarehouses = data,
      error: () => console.error('Errore nel caricamento dei warehouse')
    });
  }

  loadRegions(): void {
    this.http.get<Region[]>(`${environment.apiUrl}/tracking/regions`).subscribe({
      next: (data) => this.filteredRegions = data,
      error: () => console.error('Errore nel caricamento delle regioni')
    });
  }

  fetchStatistics(): void {
    if ((this.selectedClients && this.selectedClients.length > 0) ||
      (this.selectedBrands && this.selectedBrands.length > 0)) {

      this.loading = true;
      this.error = '';
      this.warning = '';
      this.stats = undefined;

      let clientsBrandsSelected: ClientsBrands[];
      if(this.filteredClients.length == 1) {
        this.selectedClients = [...this.filteredClients];
      }
      if (this.selectedClients.length > 0) {
        clientsBrandsSelected = this.selectedClients.map(sc => {
          // trovo il client originale da clientsBrands
          const originalClient = this.clientsBrands.find(cb => cb.clientCode === sc.clientCode);

          var filteredBrandsFromClient: Brand[] = [];
          if(this.selectedBrands.length > 0) {
            // brands effettivi = intersezione tra quelli del client e quelli selezionati
            filteredBrandsFromClient = (originalClient?.brands || []).filter(b =>
              this.selectedBrands.some(sb => sb.brandCode === b.brandCode)
            );
          }
          else {
            filteredBrandsFromClient = this.filteredBrands;
          }

          return {
            clientCode: sc.clientCode,
            clientName: sc.clientName,
            brands: filteredBrandsFromClient
          } as ClientsBrands;
        });
      } else if (this.selectedBrands && this.selectedBrands.length > 0) {
        // nessun client selezionato, ma brand sì
        clientsBrandsSelected = this.clientsBrands
          .map(cb => {
            const matchingBrands = cb.brands.filter(b =>
              this.selectedBrands.some(sb => sb.brandCode === b.brandCode)
            );
            if (matchingBrands.length > 0) {
              return {
                clientCode: cb.clientCode,
                clientName: cb.clientName,
                brands: matchingBrands
              } as ClientsBrands;
            }
            return null;
          })
          .filter(cb => cb !== null) as ClientsBrands[];

      } else {
        // né client né brand selezionati → ritorno tutto
        clientsBrandsSelected = this.clientsBrands;
      }

      // let params = new HttpParams();
      // if (clientsBrandsSelected) params = params.set('clients', JSON.stringify(clientsBrandsSelected));
      // if (this.waybillCode) params = params.set('waybillCode', this.waybillCode);
      // if (this.warehouseCode) params = params.set('warehouseCode', this.warehouseCode);
      // if (this.waybillDateStart) params = params.set('waybillDateStart', this.waybillDateStart);
      // if (this.waybillDateEnd) params = params.set('waybillDateEnd', this.waybillDateEnd);
      // if (this.waybillDealerCode) params = params.set('waybillDealerCode', this.waybillDealerCode);
      // if (this.regionCode) params = params.set('regionCode', this.regionCode);

      // this.http.get<StatisticsDTO>(`${environment.apiUrl}/statistics/counts`, { params })
      //   .subscribe({
      //     next: (data) => {
      //       this.stats = data;
      //       this.loading = false;
      //     },
      //     error: (err) => {
      //       this.error = 'Errore nel caricamento delle statistiche.';
      //       this.loading = false;
      //     }
      //   });

      const body = {
        clients: clientsBrandsSelected || undefined,
        waybillCode: this.waybillCode || undefined,
        warehouseCode: this.warehouseCode || undefined,
        waybillDateStart: this.waybillDateStart || undefined,
        waybillDateEnd: this.waybillDateEnd || undefined,
        waybillDealerCode: this.waybillDealerCode || undefined,
        regionCode: this.regionCode || undefined
      };

      this.http.post<StatisticsDTO>(`${environment.apiUrl}/statistics/counts`, body)
        .subscribe({
          next: (data) => {
            this.stats = data;
            this.loading = false;
          },
          error: (err) => {
            this.error = 'Errore nel caricamento delle statistiche.';
            this.loading = false;
          }
        });

        this.confrontaDate();
      } else {
      this.stats = undefined;
      this.warning = 'Selezionare almeno un cliente o un marchio per visualizzare le statistiche.';
    }  
  }

  resetFilters(): void {
    this.selectedClients = [];
    this.selectedBrands = [];
    this.warehouseCode = '';
    this.waybillDealerCode = '';
    this.waybillDateStart = '';
    this.waybillDateEnd = '';
    this.calcolaDataDefaultFiltri();
    this.fetchStatistics();
  }

  calcolaDataDefaultFiltri(): void {
    // Calcolo data predefinita (ieri o venerdì)
    const today = new Date();
    let defaultDate = new Date(today);

    if (today.getDay() === 0) {
      // Domenica → venerdì
      defaultDate.setDate(today.getDate() - 2);
    } else if (today.getDay() === 1) {
      // Lunedì → venerdì
      defaultDate.setDate(today.getDate() - 3);
    } else {
      // Altri giorni → ieri
      defaultDate.setDate(today.getDate() - 1);
    }

    const formattedDate = defaultDate.toISOString().split('T')[0];
    this.waybillDateStart = formattedDate;
    this.waybillDateEnd = formattedDate;
  }

  // private shiftDate(dateStr: string, days: number): string {
  //   const date = new Date(dateStr);
  //   date.setDate(date.getDate() + days);
  //   return date.toISOString().substring(0, 10); // Format: yyyy-mm-dd
  // }

  // shiftCreationDates(days: number): void {
  //   if (this.waybillDateStart) {
  //     this.waybillDateStart = this.shiftDate(this.waybillDateStart, days);
  //   }
  //   else {
  //     const today = new Date();
  //     const formattedDate = today.toISOString().split('T')[0];
  //     this.waybillDateStart = this.shiftDate(formattedDate, days);
  //   }
  //   if (this.waybillDateEnd) {
  //     this.waybillDateEnd = this.shiftDate(this.waybillDateEnd, days);
  //   }
  //   else {
  //     const today = new Date();
  //     const formattedDate = today.toISOString().split('T')[0];
  //     this.waybillDateEnd = this.shiftDate(formattedDate, days);
  //   }
  // }

    // Funzioni per navigazione date
  decrementStartDate(): void {
    if (this.waybillDateStart) {
      const date = new Date(this.waybillDateStart);
      date.setDate(date.getDate() - 1);
      this.waybillDateStart = date.toISOString().split('T')[0];
    }
  }

  incrementStartDate(): void {
    if (this.waybillDateStart) {
      const date = new Date(this.waybillDateStart);
      date.setDate(date.getDate() + 1);
      this.waybillDateStart = date.toISOString().split('T')[0];
    }
  }

  decrementEndDate(): void {
    if (this.waybillDateEnd) {
      const date = new Date(this.waybillDateEnd);
      date.setDate(date.getDate() - 1);
      this.waybillDateEnd = date.toISOString().split('T')[0];
    }
  }

  incrementEndDate(): void {
    if (this.waybillDateEnd) {
      const date = new Date(this.waybillDateEnd);
      date.setDate(date.getDate() + 1);
      this.waybillDateEnd = date.toISOString().split('T')[0];
    }
  }

}
